module.exports = __webpack_public_path__ + "static/media/currency-name.e9a35576.png";